import { z } from 'zod';

const MONEY_RE = /^-?\d+([.,]\d{1,4})?$/;

const moneyString = z
  .string()
  .trim()
  .min(1, 'Obrigatório')
  .regex(MONEY_RE, 'Valor inválido')
  .transform((s) => s.replace(',', '.'));

export const purchaseRequestInputSchema = z.object({
  referencia: z.string().trim().min(1, 'Obrigatório').max(60, 'Máximo 60 caracteres'),
  descricaoNotaFiscal: z.string().trim().max(500, 'Máximo 500 caracteres').nullable().optional(),
  valorInicial: moneyString.refine((s) => Number(s) > 0, 'Deve ser maior que zero'),
  valorComplemento: moneyString.optional(),
  clienteId: z.number().int().positive().nullable().optional(),
});

export type PurchaseRequestFormValues = z.input<typeof purchaseRequestInputSchema>;
